export const version = "hash/5.6.0";
//# sourceMappingURL=_version.js.map